import { AlpineComponent } from 'alpinejs';

export interface SecondLevelMenuInterface {
  // Used on desktop only
  open: boolean;
  menuId: string;
  closeSecondLevelMenu(): void;
  openSecondLevelMenu(menuId: string): void;
  isSecondLevelMenuOpen(menuId: string): boolean;
}

const SecondLevelMenu = (
  initial: boolean = false,
): AlpineComponent<SecondLevelMenuInterface> => ({
  open: initial,
  menuId: '',

  /**
   * Open the 2nd-level menu with the given menu Id.
   *
   * @param menuId - The menu Id
   */
  openSecondLevelMenu(menuId: string): void {
    this.open = true;
    this.menuId = menuId;
  },

  /**
   * Close the 2nd-level menu.
   */
  closeSecondLevelMenu(): void {
    this.open = false;
    this.menuId = '';
  },

  /**
   * Indicates if the 2nd-level menu is opened with the given menu Id.
   *
   * @param menuId - The menu Id
   *
   * @returns boolean
   */
  isSecondLevelMenuOpen(menuId: string): boolean {
    return this.open && this.menuId === menuId;
  },
});

export default SecondLevelMenu;
